import { find } from '../helpers';

const element = find('details')

if (element) {
    import('./index')
}
